import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'info-group',
  templateUrl: './info-group.component.html',
  styleUrls: ['./info-group.component.scss']
})
export class InfoGroupComponent {
  @Input() title: string;
  @Input() expanded = false;

  constructor() { }

  toggleExpanded(e) {
    this.expanded = !this.expanded;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/campaign-new/info-group/info-group.component.ts